import { DATE } from './meta';

export const environment = {
  ENV: 'acc',
  WEBCOMPONENT: false,
  production: true,
  DEPLOY_URL: 'https://acc.wsapp.wageindicator.org/',
  ENGINE_URL: 'https://acc.wsengine.wageindicator.org/rest/',
  WISAPI_URL: 'https://acc.wisapi.wageindicator.org/rest/trees/',
  OFFLINE: false,
  DATE: DATE,
};
